import { Box, colors } from "@mui/material";
// import { blue } from "@mui/material/colors";
// import { blue } from "@mui/material/colors";
import { format } from "date-fns";
import React from "react";

import { localStorageDict } from "../../../../services/enums/index.js";
import { useLocalStorage } from "../../../../services/hooks/index.js";

export default React.memo(() => {
  const [hostConfig] = useLocalStorage(localStorageDict.HOST_CONFIG, { name: "", website: "", features: [] });

  return (
    <Box
      flex="0 1"
      style={{
        marginTop: 50,
        backgroundColor: colors.blue[800],
        color: "white",
        textAlign: "center",
        padding: 20,
      }}
    >
      &copy;
      {" "}
      {hostConfig.name}
      {" "}
      {format(new Date(), "yyyy")}
    </Box>
  );
});
